export default __webpack_public_path__ + "static/media/ic_clock.ac877164.svg";